export default __webpack_public_path__ + "static/media/self.de716561.png";